import type { Schemas } from '#shopware'

export const mediaIncludes: Schemas['Includes'] = {
    // metaData carries the intrinsic width/height. MiscImage needs them to reserve the
    // correct box for a lazily loaded image, which is the difference between a visible
    // layout shift on load and none.
    media: ['id', 'path', 'url', 'alt', 'title', 'fileExtension', 'metaData'],
}

export const productMediaIncludes: Schemas['Includes'] = {
    product_media: ['position', 'media'],
    ...mediaIncludes,
}
